import { io } from "socket.io-client";

//Socket Client
// const URL = process.env.NODE_ENV === "production" ? undefined : "http://localhost:3001";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig().public;
  const URL = config.server;
  const socket = io(URL);
  return {
    provide: {
      io: socket,
    },
  };
});
